// extracted by mini-css-extract-plugin
export default {"popular_section":"small_slider_section_popular_section__DHmoy"};